import * as React from "react";
import Header from "pages/shared/header";
import Box from "@mui/material/Box";

import { AppProvider } from "AppContext";
import AuthProvider from "AuthContext";
import { Route, Routes } from "react-router-dom";

// Hocs
import Authenticate from "pages/authenticate";
import RequireAuth from "pages/authenticate/requireAuth";


// Pages
import Page from "pages/shared/page";
import { MdtFilters, MdtDashboardHome } from "pages/mdt";
import { NoMdtFilters, NoMdtDashboardHome } from "pages/noMdt";
import { BreastFilters, BreastDashboardHome } from "pages/breast"; 
import { CrcFilters, CrcDashboardHome } from "pages/crc";
import { BrainFilters, BrainDashboardHome } from "pages/brain";
import { LungDashboardHome, LungFilters } from "pages/lung";
import { HeadAndNeckDashboardHome, HeadAndNeckFilters } from "pages/headAndNeck";
import { YouthCancerDashboardHome, YouthCancerFilters } from "pages/youthCancer";
import { AMLDashboardHome, AMLFilters } from "pages/aml";

import * as MDT from "models/mdt";
import * as NoMDT from "models/noMdt";
import * as CRC from "models/crc";
import * as Breast from "models/breast";
import * as Lung from "models/lung";
import * as Brain from "models/brain";
import * as HAN from "models/headAndNeck";
import * as YC from "models/youthCancer";
import * as AML from "models/aml";




function App() {
    return (
        <>
			<AuthProvider>
				<AppProvider>
					<Header />	
					<Box sx={{ position: "relative", top: 80 }}>
						<Routes>
							<Route path="/" element={<RequireAuth><Page main={<MdtDashboardHome />} clearFilters={MDT.clearFilters} computeChartData={MDT.computeChartData} filterDrawer={<MdtFilters />} loadData={MDT.loadMdtDashboard}/></RequireAuth>}/>
							<Route path="/mdt-activity" element={<RequireAuth><Page main={<MdtDashboardHome />} clearFilters={MDT.clearFilters} computeChartData={MDT.computeChartData} filterDrawer={<MdtFilters />} loadData={MDT.loadMdtDashboard}/></RequireAuth>}/>
							<Route path="/treatment-activity" element={<RequireAuth><Page main={<NoMdtDashboardHome />} clearFilters={NoMDT.clearFilters} computeChartData={NoMDT.computeChartData} filterDrawer={<NoMdtFilters />} loadData={NoMDT.loadMdtDashboard}/></RequireAuth>}/>
							<Route path="/breast-indicators" element={<RequireAuth><Page main={<BreastDashboardHome />} clearFilters={Breast.clearFilters} computeChartData={Breast.computeChartData} filterDrawer={<BreastFilters />} loadData={Breast.loadBreastDashboard}/></RequireAuth>}/>
							<Route path="/lung-indicators" element={<RequireAuth><Page main={<LungDashboardHome />} clearFilters={Lung.clearFilters} computeChartData={Lung.computeChartData} filterDrawer={<LungFilters />} loadData={Lung.loadLungDashboard}/></RequireAuth>}/>
							<Route path="/crc-indicators" element={<RequireAuth><Page main={<CrcDashboardHome />} clearFilters={CRC.clearFilters} computeChartData={CRC.computeChartData} filterDrawer={<CrcFilters />} loadData={CRC.loadMdtDashboard}/></RequireAuth>}/>
							<Route path="/brain-indicators" element={<RequireAuth><Page main={<BrainDashboardHome />} clearFilters={Brain.clearFilters} computeChartData={Brain.computeChartData} filterDrawer={<BrainFilters />} loadData={Brain.loadBrainDashboard}/></RequireAuth>}/>
							<Route path="/headandneck-indicators" element={<RequireAuth><Page main={<HeadAndNeckDashboardHome />} clearFilters={HAN.clearFilters} computeChartData={HAN.computeChartData} filterDrawer={<HeadAndNeckFilters />} loadData={HAN.loadHeadAndNeckDashboard}/></RequireAuth>}/>
							<Route path="/youthcancer-indicators" element={<RequireAuth><Page main={<YouthCancerDashboardHome />} clearFilters={YC.clearFilters} computeChartData={YC.computeChartData} filterDrawer={<YouthCancerFilters />} loadData={YC.loadYouthCancerDashboard}/></RequireAuth>}/>
							<Route path="/aml-indicators" element={<RequireAuth><Page main={<AMLDashboardHome />} clearFilters={AML.clearFilters} computeChartData={AML.computeChartData} filterDrawer={<AMLFilters />} loadData={AML.loadAMLDashboard}/></RequireAuth>}/>
							<Route path="/auth/:oneTimeToken" element={<Authenticate />}/>
						</Routes>
					</Box>
				</AppProvider>
			</AuthProvider>
        </>
    )
}

export default App;